import locationLaunchpadConfig from './location/launchpad'
import agencyLaunchpadConfig from './agency/launchpad'
import { SideBarItemConfig, Permissions, Scopes } from './baseSideBarItemConfig'

// TODO: Add more agency navigation items here
const agencyNavigation = [agencyLaunchpadConfig]

// TODO: Add more location navigation items here
const locationNavigation = [locationLaunchpadConfig]

export {
  SideBarItemConfig,
  Permissions,
  Scopes,
  agencyNavigation,
  locationNavigation,
}
